module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification",
    class: _vm.notification.cssClasses(),
    on: {
      "click": _vm.navigate
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.remove.apply(null, arguments)
      }
    }
  }), _c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.name) + " recebeu "), _c('span', [_c('span', {
    staticClass: "entity-type"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" convertido(s) via RD Station.")])]), _c('div', {
    staticClass: "time",
    class: {
      left: _vm.table
    }
  }, [_vm._v(_vm._s(_vm.notification.timeText()))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40accd7e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/notifications/kind/updated_rd_station.vue
// module id = 1090
// module chunks = 1